// assets/section-tabbed-image.js

(function() {
  // Keep in sync with CSS transition duration (350ms)
  var FADE_MS = 350;

  function initTabbedImage(root) {
    if (!root) return;

    var labels = root.querySelectorAll('.tabbed-image__tab');
    var panels = root.querySelectorAll('.tabbed-image__panel');

    function showPanel(targetId) {
      // Fade target in, others out
      for (var i = 0; i < panels.length; i++) {
        var p = panels[i];
        var isTarget = (p.id === targetId);

        if (isTarget) {
          if (p.style.opacity != 0) p.style.opacity = 1;
          requestAnimationFrame((function(panel) {
            return function() { panel.classList.add('is-visible'); };
          })(p));
        } else {
          if (p.classList.contains('is-visible')) {
            p.classList.remove('is-visible');
            (function(panel) {
              setTimeout(function() {
                if (!panel.classList.contains('is-visible')) {
                  // panel.style.opacity = 0;
                }
              }, FADE_MS);
            })(p);
          } else {
            // p.style.opacity = 0;
          }
        }
      }

      // Update tabs' active state + aria
      for (var j = 0; j < labels.length; j++) {
        var lbl = labels[j];
        var active = (lbl.getAttribute('data-panel') === targetId);
        lbl.classList.toggle('is-active', active);
        lbl.setAttribute('aria-selected', active ? 'true' : 'false');
      }
    }

    var initial = root.querySelector('.tabbed-image__tab.is-active') || root.querySelector('.tabbed-image__tab');
    if (initial) showPanel(initial.getAttribute('data-panel'));

    for (var k = 0; k < labels.length; k++) {
      labels[k].addEventListener('mouseenter', function() {
        var pid = this.getAttribute('data-panel');
        if (pid) showPanel(pid);

        var forId = this.getAttribute('for');
        if (forId) {
          var input = root.querySelector('#' + forId);
          if (input) input.checked = true;
        }
        var pid = this.getAttribute('data-panel');
        if (pid) showPanel(pid);
      });
    }
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function() {
    // Initialize all instances on the page
    var sections = document.querySelectorAll('.section--tabbed-image[id^="tabbed-image-"]');
    for (var i = 0; i < sections.length; i++) {
      initTabbedImage(sections[i]);
    }
  });
})();
